export default __webpack_public_path__ + "static/media/circle-chevron-top.db176314.svg";